import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';
import * as Dialog from '@radix-ui/react-dialog';

const Overlay = styled(Dialog.Overlay)`
  background-color: rgba(0, 0, 0, 0.25);
  position: fixed;
  z-index: 200;
  inset: 0;
  display: grid;
  place-items: center;
  overflow-y: auto;
`;

const Content = styled(Dialog.Content)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  margin-top: 118px;
  width: 834px;
  height: auto;
  padding: 45px;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ContentFooter = styled.div`
  padding-top: 24px;
  display: flex;
  width: 100%;
  gap: 16px;
`;

const CloseButton = styled(Dialog.Close)`
  cursor: pointer;
`;

const FieldSet = styled.fieldset`
  padding: 24px 0;
  border: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const S = {
  ...UIElements,
  Overlay,
  Content,
  ContentHeader,
  ContentFooter,
  CloseButton,
  FieldSet,
};
